import { gql } from '@/lib/graphql/gql'

export const PROJECT_DISPLAY_NAME_QUERY = gql`
  query ProjectDisplayName($idCompany: String!, $projectName: String!) {
    company(id: $idCompany) {
      id
      projectByName(name: $projectName) {
        id
        name
        displayName
      }
    }
  }
`
